module.exports = __webpack_public_path__ + "media/images/home/ic_duplicate-925aa1ada5604873abfb304c5655381c.svg";